<div fxLayout="row" fxLayoutAlign="{{align}} center" fxLayoutGap="5px" *ngIf="response && states">
  <mat-form-field>
    <mat-progress-bar [mode]="'indeterminate'" *ngIf="progress"></mat-progress-bar>
    <mat-select  [formControl]="control"
                 placeholder="Etat de la demande"
                [disabled]="isDisabled()"
                [(ngModel)]="stateCurrent"
                 [matTooltip]="stateTooltip()"
                (selectionChange)="onSelect($event)"
                data-cy="select-response-state-instruction-ask-state">
      <mat-select-trigger>
        <mat-icon>{{stateCurrent?.icon}}</mat-icon>&nbsp;{{stateCurrent?.label}}
      </mat-select-trigger>
      <mat-option *ngFor="let state of states" [value]="state" [attr.data-cy]="'option-response-states-instructions-'+state.id">
          <span [matTooltip]="state?.explain"><mat-icon [ngStyle]="{'color': state?.color || 'initial'}">{{state?.icon}}</mat-icon></span>
          <span>{{state?.label}}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
